import { Storage } from './../../../core/services/storage.service';
import { ClientEnum } from './../../../core/enum/client.enum';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { StorageCollections } from 'src/app/core/enum/storage-collections.enum';
import { RedirctUrlService } from '../redirct-url.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerSupportService {
  public apiUrl = environment.runtime.userManagementApiUrl;

  constructor(private _httpClient: HttpClient,
    private _redirectSvc: RedirctUrlService,
    private storage: Storage) { }

  /**
   * Impersonate target user
   * @param username
   */
  public async imporsonateUser(username: string, organizationType: string) {
    if (!username) throw Error("No user to impersonate!");
    try {
      const tempPassword = (await this._getTempPassword(organizationType))['token'].toString();
      const token = await this._getToken(username, tempPassword);
      await this._saveImpersonatorInfo();
      await this._impersonateUser(token);
    } catch (err) {
      throw err;
    }
  }


  public async revertToAdminUser() {
    try {
      const impersonator = JSON.parse(await this.storage.getItem('impersonator'));
      if (impersonator && impersonator.token) {
        const token = {
          access_token: impersonator.token,
          refresh_token: impersonator.refresh_token,
          expires_in: ((impersonator.expires_in - Date.now())/1000)
        }
        await this._impersonateUser(token);
        await this.storage.removeItem(StorageCollections.SECURITY, 'impersonator');
        this._redirectSvc.navigateToBaseUrl();
      }
    } catch(err) {
      throw err;
    }
}

  /**
   * Search users
   * @param searchText
   * @param userType
   */
  public searchUsers(searchText: string, userType: string) {
    if (!searchText || !userType) throw Error("No search text or user type found.");

    var url = `${this.apiUrl}/user/dropdown/${userType}?searchText=${encodeURIComponent(searchText)}`;
    return this._httpClient.get(url).toPromise();
  }

  /**
   * Impersonate target user by replacing token info in IndexDB
   * @param token
   */
  private async _impersonateUser(token: any) {
    await this.storage.setItem('access_token', token.access_token);
    await this.storage.setItem('refresh_token', token.refresh_token);
    const tokenExpiration = Date.now() + token.expires_in * 1000;
    await this.storage.setItem('expire_time', tokenExpiration.toString());
  }

  /**
   * Save impersonator token and user before switching target userLogin
   * We will use this token to switch to other user if needed
   */
  private async _saveImpersonatorInfo() {
    const impersonator = await this.storage.getItem('impersonator');
    if (!impersonator && !impersonator.token) {
      const impersonateToken = await this.storage.getItem('access_token');
      const impUser = await this.storage.getItem('user');
      const refreshToken = await this.storage.getItem('refresh_token');
      const expiresIn = await this.storage.getItem('expire_time');
      const impersonator = { token: impersonateToken, user: impUser, refresh_token: refreshToken, expires_in: expiresIn };
      await this.storage.setItem('impersonator', JSON.stringify(impersonator));
    }
  }

  /**
   * Get temporary password for current user user
   * Current user must have HC_INTERNAL_CUST_SUPPORT
   */
  private _getTempPassword(organizationType: string) {
    return this._httpClient.post(`${this.apiUrl.replace("/hubconnectusermanagementapi","")}/auth/support`, {organizationType: organizationType}).toPromise();
  }

  /**
   * Get token for given username from auth with temporary password
   * @param username
   * @param password
   */
  private _getToken(username: string, password: string) {
    if (!username || !password) throw Error('No username/password found');

    const grantType = `grant_type=password`;
    const clientId = `client_id=${ClientEnum.ID}`;
    const clientSecret = `client_secret=${ClientEnum.SECRET}`;
    const scope = `scope=role%3developer`;
    const un = `username=${encodeURIComponent(username)}`;
    const pw = `password=${encodeURIComponent(password)}`;

    const opts = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    const body = `${grantType}&${clientId}&${clientSecret}&${scope}&${un}&${pw}`;

    return this._httpClient.post(`${this.apiUrl.replace("/hubconnectusermanagementapi","")}/auth/oauth/token`, body, opts).toPromise();
  }
}
